// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div.card[data-v-cae6948a]{background-color:#fff;border-radius:20px;padding:10px}@media(prefers-color-scheme:dark){div.card[data-v-cae6948a]{background-color:#111}}div.card.card-outline[data-v-cae6948a]{background-color:transparent;border:1px solid #f5f5f5;border-radius:0;padding:10px}@media(prefers-color-scheme:dark){div.card.card-outline[data-v-cae6948a]{background-color:transparent;border:1px solid #1d1d1d}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
